import { createContext, useContext } from 'react';

import type { ShellControl } from '@/types/panels';

/**
 * Global shell-control surface for agent UI tools. Published by AppShell so
 * the chat panel's UI-tool executors can drive arbitrary panels and read the
 * current view state — a wider API than the per-panel PanelContext.
 *
 */
export const ShellControlContext = createContext<ShellControl | null>(null);

export function useShellControl(): ShellControl {
    const ctx = useContext(ShellControlContext);
    if (!ctx) {
        throw new Error('useShellControl used outside of <ShellControlContext.Provider>');
    }
    return ctx;
}
